import ACTION_TYPES from '../actionTypes'

const actionCreators = {
  batchActions: actionArray => ({ type: ACTION_TYPES.BATCH_ACTIONS, actionArray }),
}

export { actionCreators }
export default actionCreators
